import { ReusableSection } from 'components/ReusableSection';
import { Faqs } from 'components/Faqs';
import { Hero } from 'components/Hero';
import { LandingBanner } from 'components/LandingBanner';
import { LandingConsultation } from 'components/LandingConsultation';
import { PortfolioPreview } from 'components/PortfolioPreview';
import { ServiceAreaHighlight } from 'components/ServiceAreaHighlight';
import { BeforeAfterComparison } from 'components/BeforeAfterComparison';
import { Helmet } from 'react-helmet-async';
const kitchenRemodel =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597871/oak-and-stone-remodel/show/show1.webp';
const kitchenRemodelTwo =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597881/oak-and-stone-remodel/show/show20.webp';

export const Landing = () => {
  const aboutContent = [
    "A beautiful home is more than just a place to return to — it's a personal haven for peaceful retreats, quality family time, and welcoming friends and guests.",
    "Oak and Stone Residential Construction, based in Tremonton, UT, is a fully licensed contractor offering a complete range of remodeling services. From custom designs to full-scale construction, we're here to transform your space and be your trusted renovation partner!"
  ];

  const processContent = [
    "At Oak and Stone Construction, we've streamlined our process to make your remodeling journey as smooth and stress-free as possible. It starts with a consultation where we listen to your needs, ideas, and vision for your space. We then move to the design phase, creating custom plans that bring your vision to life.",
    'Once the design is finalized, our skilled team gets to work on construction, keeping you updated every step of the way. The final result is a beautifully transformed space that exceeds your expectations.'
  ];

  return (
    <>
      <Helmet>
        <title>Utah Kitchen & Bath Remodeling | Oak & Stone Construction</title>
        <meta
          name="description"
          content="Transform your Utah home with expert kitchen, bath, and cabinet remodeling. Serving Weber, Davis & Box Elder County. Free consultation from Oak & Stone Construction!"
        />
        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Expert Kitchen & Bathroom Remodeling in Weber, Davis & Box Elder | Oak & Stone Construction"
        />
        <meta
          property="og:description"
          content="Transform your home with expert kitchen and bathroom remodeling in Weber, Davis, and Box Elder counties. Oak & Stone Construction specializes in custom cabinets and high-quality renovations. Get a free consultation today!"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597871/oak-and-stone-remodel/show/show1.webp"
        />
        <meta property="og:url" content="https://oakandstoneremodel.com/" />
        <meta property="og:type" content="website" />
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Expert Kitchen & Bathroom Remodeling in Weber, Davis & Box Elder | Oak & Stone Construction"
        />
        <meta
          name="twitter:description"
          content="Transform your home with expert kitchen and bathroom remodeling in Weber, Davis, and Box Elder counties. Oak & Stone Construction specializes in custom cabinets and high-quality renovations. Get a free consultation today!"
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597871/oak-and-stone-remodel/show/show1.webp"
        />
        <meta name="twitter:url" content="https://oakandstoneremodel.com/" />
        <link rel="canonical" href="https://oakandstoneremodel.com/" />
      </Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: 'Kitchen & Bathroom Remodeling',
          provider: {
            '@type': 'Organization',
            name: 'Oak & Stone Construction',
            url: 'https://oakandstoneremodel.com/'
          },
          areaServed: [
            'Weber County',
            'Davis County',
            'Box Elder County',
            'Utah'
          ],
          serviceType: [
            'Kitchen Remodeling',
            'Bathroom Remodeling',
            'Custom Cabinets',
            'Home Renovation',
            'Interior Remodeling',
            'Additions',
            'Custom Woodwork'
          ],
          description:
            'Transform your home with expert kitchen and bathroom remodeling, custom cabinets, and high-quality renovations in Weber, Davis, and Box Elder counties.'
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Expert Kitchen & Bathroom Remodeling in Weber, Davis & Box Elder | Oak & Stone Construction',
          url: 'https://oakandstoneremodel.com/',
          description:
            'Transform your home with expert kitchen and bathroom remodeling in Weber, Davis, and Box Elder counties. Oak & Stone Construction specializes in custom cabinets and high-quality renovations. Get a free consultation today!'
        })}
      </script>
      <div className="overflow-hidden pb-24 mx-auto space-y-8">
        <Hero />
        <PortfolioPreview />
        <BeforeAfterComparison />
        <ServiceAreaHighlight />
        <Faqs />
        <LandingBanner />
        <ReusableSection
          image={kitchenRemodel}
          altText="kitchen remodel including cabinets, countertop and a beautiful backsplash"
          title="Premier Utah Home Remodeling: Oak and Stone Construction"
          content={aboutContent}
          buttonText="Meet the team"
          buttonLink="/about"
        />
        <LandingConsultation />
        <ReusableSection
          image={kitchenRemodelTwo}
          altText="Beautifully remodeled kitchen space"
          title="Our Process"
          content={processContent}
          buttonText="Our Process"
          buttonLink="/process"
        />
      </div>
    </>
  );
};
